import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_FAMILIES, FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

const Wrapper = styled.div`
  //
`;

const Heading = styled.h2`
  ${customTextSize(24, 30)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  letter-spacing: -0.01em;
  margin-bottom: 40px;
  text-align: center;

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(32, 38)}
    margin-bottom: 60px;
  }

  ${mediaBreakpointUp('desktopWide')} {
    margin-bottom: 90px;
  }
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  ${mediaBreakpointUp('tablet')} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 20px;
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-template-columns: repeat(20, 1fr);
  }
`;

const StatisticWrapper = styled.div`
  ${customTextSize(14, 19)}
  text-align: center;

  ${mediaBreakpointUp('tablet')} {
    grid-column-end: span 4;
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(16, 24)}
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column-end: span 6;
    padding: 0 20px;

    &:first-of-type {
      grid-column-start: 2;
    }
  }
`;

interface LogoContainerProps {
  $isTaller: boolean;
}

const LogoContainer = styled.div<LogoContainerProps>`
  position: relative;
  margin: 0 auto;

  img {
    margin: 0 auto;
    width: auto;
    height: ${(props) => (props.$isTaller ? 52 : 39)}px;
  }

  ${mediaBreakpointUp('tablet')} {
    display: flex;
    align-items: flex-end;
  }

  ${mediaBreakpointUp('desktop')} {
    margin-bottom: 8px;

    img {
      height: ${(props) => (props.$isTaller ? 65 : 48)}px;
    }
  }
`;

const Statistic = styled.div`
  ${customTextSize(52, 65)}
  font-family: ${FONT_FAMILIES.SERIF};
  font-weight: ${FONT_WEIGHTS.BOLD};
  letter-spacing: -0.01em;
  margin-bottom: 2px;

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(86, 84)}
    margin-bottom: 8px;
  }
`;

const statisticsBlockComponents = {
  Wrapper,
  Heading,
  Grid,
  StatisticWrapper,
  LogoContainer,
  Statistic,
};

export default statisticsBlockComponents;
